<template>
  <div class="auth-page-container">
    <h2 class="auth-page-title font-500">
      {{ $t('trade.history') }}
    </h2>
    <div class="auth-page-section" ref="trade-history-container">
      <b-form v-show="true" @submit.prevent="search" class="mx-2">
        <b-row>
          <div class="col-12 col-md-6 mb-ten">
            <auto-complete
              :items="brands"
              :placeholder="$t('keyword')"
              :buttonVisible="false"
              :required="false"
              displayValue="symbol"
              @query="getBrands"
              @selected="setBrandQuery"
              @click="initBrandQuery"
              is-brand
            />
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <date-picker
                :max-date="new Date()"
                @change="dateChange"
                range
                :datesProp="initialDates"
                class="mr-3"
              />
              <ic-button size="tn" type="submit" class="card-button mt-0">
                {{ $t('helper.search') }}
              </ic-button>
            </div>
          </div>
        </b-row>
      </b-form>
      <div class="table-container">
        <table class="ic-table">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('trade.symbol') }}</th>
              <th>{{ $t('trade.date') }}</th>
              <th>{{ $t('trade.side') }}</th>
              <th class="right">{{ $t('trade.unit_price') }}</th>
              <th class="right">{{ $t('trade.quantity') }}</th>
              <th class="right">{{ $t('trade.total_amount') }}</th>
              <th class="right">{{ $t('order.fee') }}</th>
              <th>{{ $t('order.status') }}</th>
            </tr>
          </thead>
          <tbody v-if="items && items.length">
            <tr v-for="(trade, i) in items" :key="`body-${i}`">
              <td>{{ i + 1 }}</td>
              <td>{{ trade.symbol | symbol }} <span class="exchange-code">/ {{ trade.exchange_server_code ?? '--' }}</span></td>
              <td>{{ trade.created_at | formatDate('dateTime') }}</td>
              <td :class="['side-cell', trade.side === 1 ? 'is-buy' : 'is-sell']">
                {{ trade.side === 1 ? $t('order.buy') : $t('order.sell') }}
              </td>
              <td class="right">{{ trade.unit_price | currency }}</td>
              <td class="right">{{ trade.quantity }}</td>
              <td class="right">{{ trade.total_amount | currency }}</td>
              <td class="right">{{ parseFloat(trade.commission).toFixed(2) | currency }}</td>
              <!-- <td>{{ $t('order.state.' + trade.exec_type) }}</td> -->
              <td
                :class="[
                  trade.exec_type == 'P' ? 'text-yellow' : '',
                  trade.exec_type == 'F' ? 'text-green' : '',
                  trade.exec_type == '4' ||
                  trade.exec_type == 'C' ||
                  trade.exec_type == '8' ||
                  trade.exec_type == '6'
                    ? 'text-red'
                    : '',
                ]"
              >
                <span v-if="trade.exec_type != 'P'">{{
                  $t('order.state.' + trade.exec_type)
                }}</span>
                <span
                  v-else
                  class="d-flex align-items-center"
                  @click="showTradeDetails(trade)"
                  :style="trade.exec_type == 'P' ? 'cursor: pointer;' : ''"
                  >{{ $t('order.state.' + trade.exec_type) }}
                  <i class="sr sr-eye-open ml-2"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination-nav
        v-model="page.number"
        align="center"
        :link-gen="linkGen"
        :number-of-pages="page.totalPages || 1"
        use-router
      />
    </div>
    <ic-dialog :show="showTradeDetailsDialog">
      <div class="dialog-box" style="width: auto; overflow: auto; max-height: 70vh">
        <div class="row align-items-center mb-ten">
          <div class="col">
            <h3 v-if="selectedItem" class="mb-0">
              {{ selectedItem.symbol | symbol }} {{ $t('helper.more') }}
            </h3>
          </div>
          <a
            @click.stop="showTradeDetailsDialog = false"
            class="icon-btn close-btn mr-row"
          >
            <i class="sr sr-close"></i>
          </a>
        </div>
        <table class="ic-table md mb-ten">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('trade.date') }}</th>
              <th class="right">
                {{ $t('order.unit-price') }}
              </th>
              <th class="right">{{ $t('trade.quantity') }}</th>
              <th class="right">Биелсэн</th>
              <th class="right">Үлдсэн</th>
              <th class="right">{{ $t('order.fee') }}</th>
              <th class="right">{{ $t('trade.total_amount') }}</th>
            </tr>
          </thead>
          <tbody
            v-if="
              selectedItem &&
              selectedItem.order_details &&
              selectedItem.order_details.length
            "
          >
            <tr
              v-for="(item, i) in selectedItem.order_details"
              :key="`order${i}`"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ item.created_at | formatDate('dateTime') }}</td>
              <td class="right">{{ item.last_px || 0 | currency('', '₮') }}</td>
              <td class="right">
                {{
                  calcLeft(
                    selectedItem.quantity,
                    selectedItem.order_details,
                    i
                  ) || 0 | currency('no-precision', '')
                }}
              </td>
              <td class="right">
                {{ item.last_qty || 0 | currency('no-precision', '') }}
              </td>
              <td class="right">
                {{ item.leaves_qty || 0 | currency('no-precision', '') }}
              </td>
              <td class="right">
                {{ item.fee | '*.*' | currency('', '₮') }}
              </td>
              <td class="right">
                {{
                  (parseInt(item.last_px) * parseInt(item.last_qty) +
                    parseFloat(item.fee) || '*.*') | currency('', '₮')
                }}
              </td>
            </tr>
          </tbody>
          <span v-else>
            {{
              $t('helper.not-found-slot', {
                slot: $tc('helper.more', 1),
              })
            }}</span
          >
        </table>
        <div
          style="opacity: 50%"
          v-if="selectedItem && selectedItem.sent === 3"
        >
          Цуцалсан
        </div>
      </div>
    </ic-dialog>
  </div>
</template>
<script>
import AutoComplete from '../components/AutoComplete'
import api from '../api/stoTrade'
import { ExecType } from '../constants'
import PageLayout from '../components/PageLayout'
import OrderInfo from '../components/OrderInfo'
import DatePicker from '../components/DatePicker'
import moment from 'moment'

export default {
  name: 'tradeHistoryView',
  components: {
    AutoComplete,
    OrderInfo,
    PageLayout,
    DatePicker,
  },
  data() {
    const initial = {
      start: moment().subtract(1, 'months').toDate(),
      end: new Date(),
    }
    return {
      ExecType,
      initialDates: initial,
      isLoading: false,
      page: {
        number: 0,
        totalPages: 1,
      },
      brands: [],
      filters: {
        symbol: '',
        from: '',
        to: '',
      },
      tableData: {},
      tradeProfit: null,
      items: [],
      selectedItem: null,
      showTradeDetailsDialog: false,
    }
  },
  computed: {
    tradeHistory() {
      return this.$store.getters.tradeHistory
    },
    shareBalance() {
      return this.$store.getters.shareBalance
    },
  },
  created() {
    this.getBrands = _.debounce(this.getBrands, 400)
    Promise.all([
      this.$store.dispatch('fetchTradeHistory', {
        page: this.page.number,
        filters: this.filters,
      }),
      this.$store.dispatch('fetchShareBalance'),
    ]).then(() => {
      this.setTableData()
    })
  },
  mounted() {
    this.fetchData()
    this.getBrands()
  },
  methods: {
    calcLeft(qty, item, index) {
      if (index > 0) {
        return item[index - 1].leaves_qty
      } else {
        return qty
      }
    },
    showTradeDetails(item) {
      this.selectedItem = item
      this.showTradeDetailsDialog = true
    },
    dateChange({ start, end }) {
      if (start && end) {
        this.filters.from = moment(start).format('YYYY-MM-DD')
        this.filters.to = moment(end).format('YYYY-MM-DD')
      }
    },
    getRequestQuery() {
      this.mapQueryToFilters()
      const query = this.mapFiltersToQuery()
      return { ...query, per_page: 12 }
    },
    mapQueryToFilters() {
      const { page, ...filters } = this.$route.query
      this.filters = { ...this.filters, ...filters }
      if (page) this.page.number = _.parseInt(page)
    },
    mapFiltersToQuery() {
      const nonEmptyFilters = _.pickBy(
        this.filters,
        (v) => !_.isEmpty(v) || !!v
      )
      return {
        ...nonEmptyFilters,
        page: this.page.number,
      }
    },
    linkGen(page) {
      const query = { ...this.$route.query }
      if (!query.page && page === 1) {
        return { query }
      }
      query.page = page
      return { query }
    },
    async fetchData() {
      this.isLoading = true
      try {
        const {
          data: { data, ...page },
        } = await api.tradeHistory(this.getRequestQuery())
        this.page = { totalPages: page.last_page, number: page.current_page }
        this.items = [...data]
      } catch (e) {
        console.error(e)
      } finally {
        if (this.$refs['order-history-container'])
          this.$refs['order-history-container'].scrollTo(0, 0)
      }
      this.isLoading = false
    },
    search() {
      this.page.number = 0
      const query = this.mapFiltersToQuery()
      this.$router.push({ query })
    },
    // Methods for autocomplete
    async getBrands(query) {
      this.isLoading = true
      try {
        let {
          data: { data },
        } = await api.brandList({ word: query, page: 0, per_page: 50 })
        this.brands = data
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
    initBrandQuery() {
      if (!this.filters.symbol) this.getBrands('')
    },
    setBrandQuery(value) {
      this.filters.symbol = value ? value.symbol : null
    },
  },
  watch: {
    '$route.query': {
      handler: 'fetchData',
      deep: true,
    },
  },
}
</script>

<style scoped>
.collapse-btn {
  border-radius: 25px;
}
.collapse-btn:disabled {
  color: #5e5e5e;
  background-color: #ddd;
  border-color: #eee;
  cursor: not-allowed;
}

.side-cell.is-buy {
  color: rgb(var(--rgb-system-green));
}

.side-cell.is-sell {
  color: rgb(var(--rgb-system-red));
}
</style>

<style lang="scss" src="../../sass/partials/sidebar-submenu.scss"></style>
